module.exports = __webpack_public_path__ + "static/img/game_bg_2.06b9c318.png";